import { Component } from '@angular/core';
import { ClassTransformerHelper } from '../../../../helpers/class.transformer.helper';
import { WorkflowType } from '../../../../models/enums/workflowtype.enum';
import { KIDefinitionService } from '../../../../services/kidefinition.service';
import { WorkflowExitInfo, WorkflowModuleSettingsHelper, WorkflowRegistry } from '../../../../services/workflow.service';
import { FormulaWorkflowDialogContent } from '../../../workflow.dialog';

@Component({
    selector: 'wf-askki-settings',
    templateUrl: './askki.settings.html'
})
export class AskKISettings extends FormulaWorkflowDialogContent {
    Data = new AskKISettingsData();
    KIDefinitions: any[] = [];
    AvailableModels: string[] = [];
    AvailableMCPServers: any[] = [];

    public static GetRegistry(): WorkflowRegistry {
        const reg = new WorkflowRegistry();
        reg.ID = 'askkiWFModule';
        reg.Caption = '@@KI: Frage stellen';
        reg.GroupID = 'aioperations';
        reg.Index = 100;
        reg.SettingsControl = AskKISettings;
        reg.SettingsTypeHelper = new AskKISettingsDataHelper();
        reg.WorkflowType = WorkflowType.Service;
        return reg;
    }

    constructor(private service: KIDefinitionService) {
        super();
    }

    ngOnInit() {
        this.service.GetKIDefinitions('Chat').subscribe(list => {
            this.KIDefinitions = list || [];
            if (this.Data.KIDefinition) {
                this.loadKIDefinitionDetails(this.Data.KIDefinition);
            }
        });
    }

    initialize(data: any) {
        super.initialize(data);
        if (data) {
            this.Data = ClassTransformerHelper.CopyObject(data, AskKISettingsData);
        }
    }

    onKIDefinitionChange() {
        this.Data.Model = '';
        this.Data.UseMCPServers = [];
        this.AvailableModels = [];
        this.AvailableMCPServers = [];
        if (this.Data.KIDefinition) {
            this.loadKIDefinitionDetails(this.Data.KIDefinition);
        }
    }

    private loadKIDefinitionDetails(id: string) {
        this.service.LoadKIDefinition(id).subscribe(def => {
            if (!def) return;
            const all = def.Models || [];
            const filtered = all.filter(m => (m.Capabilities & 1) !== 0);
            // Fall back to all configured models when no entry is flagged for the
            // capability — better UX than an empty dropdown when capability flags
            // are not (yet) set up correctly.
            this.AvailableModels = (filtered.length > 0 ? filtered : all).map(m => m.Name);
            this.AvailableMCPServers = def.MCPServers || [];
        });
    }

    getResult() {
        return this.Data;
    }
}

export class AskKISettingsData {
    KIDefinition: string;
    Model: string = '';
    SystemPrompt: string = '';
    Prompt: string = '';
    JsonSchema: string = '';
    UseMCPServers: string[] = [];
    Temperature: number = 0;
    MaxTokens: number = 0;
}

export class AskKISettingsDataHelper extends WorkflowModuleSettingsHelper {
    getExitPoints(settings: any): WorkflowExitInfo[] {
        return [new WorkflowExitInfo()];
    }
    getEmptySettingsInstance() {
        return new AskKISettingsData();
    }
}
